<div [class.small]="!count" [class.important]="important">
  {{ count || '' }}
</div>
